export const modalConstants = {
  UPDATE_LOGIN_MODAL: "UPDATE_LOGIN_MODAL",
 
};
